import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  profileFailure,
  profileStart,
  profileSuccess,
} from "../Reducers/ProfileReducer";
import Cookies from "js-cookie";
import axios from "axios";
export const Profile = createAsyncThunk("auth", async (values, thunkAPI) => {
  try {
    thunkAPI.dispatch(profileStart());
    const token = Cookies.get("token");
    const config = {
      headers: {
        Authorization: token,
      },
    };

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}AdminRoutes/MyProfile`,
      config
    );
    const responseData = await response;

    thunkAPI.dispatch(profileSuccess(responseData));

    return responseData;
  } catch (error) {
    thunkAPI.dispatch(profileFailure(error.response.data.message));

    throw error;
  }
});
